import API from "./Api";

// Department Services

export const addDepartment = async (payload) => {
  const res = await API.post("/admin/department/add", payload);
  return res.data; // ApiResponse
};

export const updateDepartment = async (id, payload) => {
  const res = await API.put(`/admin/department/update/${id}`, payload);
  return res.data;
};

export const getAllDepartments = async () => {
  const res = await API.get("/admin/department/all");
  return res.data;
};

export const getActiveDepartments = async () => {
  const res = await API.get("/admin/department/active-departments");
  return res.data;
};

export const toggleDepartmentStatus = async (id) => {
  const res = await API.patch(`/admin/department/toggle/${id}`);
  return res.data;
};


// Designation Services

export const addDesignation = async (payload) => {
  const res = await API.post("/admin/designation/add", payload);
  return res.data;
}

export const updateDesignation = async (id, payload) => {
  const res = await API.put(`/admin/designation/update/${id}`, payload);
  return res.data;
}

export const getAllDesignations = async () => {
  const res = await API.get("/admin/designation/all");
  return res.data
}

export const getActiveDesignations = async () => {
  const res = await API.get("/admin/designation/active-designation");
  return res.data;
};

export const toggleDesignationStatus = async (id) => {
  const res = await API.patch(`/admin/designation/toggle/${id}`);
  return res.data;
};



// Employees Services

export const addEmployee = async (payload) => {
  const res = await API.post("/admin/employees/add", payload);
  return res.data;
};

export const updateEmployee = async (id, payload) => {
  const res = await API.put(`/admin/employees/update/${id}`, payload);
  return res.data;
};

export const getAllEmployees = async () => {
  const res = await API.get("/admin/employees/all");
  return res.data;
};

export const getActiveEmployees = async () => {
  const res = await API.get("/admin/employees/active");
  return res.data;
};

export const toggleEmployeeStatus = async (id) => {
  const res = await API.patch(`/admin/employees/toggle/${id}`);
  return res.data;
};


// Employee Access

export const getEmployeeMenuAccess = async (employeeId) => {
  const res = await API.get(`/admin/employee-access/${employeeId}`);
  return res.data;
};

export const saveEmployeeMenuAccess = async (payload) => {
  const res = await API.post(`/admin/employee-access/save`, payload);
  return res.data;
};

// Ward
export const addWard = async (payload) => {
  const res = await API.post("/admin/wards/add", payload);
  return res.data;
};

export const updateWard = async (id, payload) => {
  const res = await API.put(`/admin/wards/update/${id}`, payload);
  return res.data;
};

export const getAllWards = async () => {
  const res = await API.get("/admin/wards/all");
  return res.data;
};

export const toggleWardsStatus = async (id) => {
  const res = await API.patch(`/admin/wards/toggle/${id}`);
  return res.data;
};

// Committee

export const addCommittee = async (payload) => {
  const res = await API.post("/admin/committee/add", payload);
  return res.data;
}

export const updateCommittee = async (id, payload) => {
  const res = await API.put(`/admin/committee/update/${id}`, payload);
  return res.data;
}

export const getAllCommittees = async () => {
  const res = await API.get("/admin/committee/all");
  return res.data;
};

export const toggleCommitteeStatus = async (id) => {
  const res = await API.patch(`/admin/committee/toggle/${id}`);
  return res.data;
};




// Work Types

export const addWorkType = async (payload) => {
  const res = await API.post("/work-type/add", payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res.data;
}

export const updateWorkType = async (id, payload) => {
  const res = await API.put(`/work-type/update/${id}`, payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res.data;
}

export const getAllWorkTypes = async () => {
  const res = await API.get("/work-type/all");
  return res.data;
};

export const toggleWorkTypeStatus = async (id) => {
  const res = await API.patch(`/work-type/toggle/${id}`);
  return res.data;
};



// Tender Types

// based on this below controller provide me the addTenderType service
//  @PostMapping("/add")
//   @PreAuthorize("hasRole('ADMIN')")
//   @Operation(summary = "Create a new tender type", description = "Create a new tender type")
//   public ResponseEntity<ApiResponse<TenderTypeResponseDTO>> createTenderType(@RequestParam String tenderTypeName) {
//       return ResponseEntity
//               .ok(ApiResponse.success("Tender type created successfully", tenderTypeService.create(tenderTypeName)));
//   }

// now provide me
export const addTenderType = async (payload) => {
  const res = await API.post("/tender-type/add", payload);
  return res.data;
}


export const updateTenderType = async (id, payload) => {
  const res = await API.put(`/tender-type/update/${id}`,payload);
  return res.data;
}

export const getAllTenderTypes = async () => {
  const res = await API.get("/tender-type/all");
  return res.data;
};

export const toggleTenderTypeStatus = async (id) => {
  const res = await API.patch(`/tender-type/toggle/${id}`);
  return res.data;
};



// Alert Types

export const addAlertType = async (payload) => {
  const res = await API.post("/admin/alert-type/add", payload);
  return res.data;
}

export const updateAlertType = async (id, payload) => {
  const res = await API.put(`/admin/alert-type/update/${id}`, payload);
  return res.data;
}

export const getAllAlertTypes = async () => {
  const res = await API.get("/admin/alert-type/all");
  return res.data;
};

export const toggleAlertTypeStatus = async (id) => {
  const res = await API.patch(`/admin/alert-type/toggle/${id}`);
  return res.data;
};

